import { Action, ActionType, Network } from "../types";

export function network(
  state: Network = {
    error: {
      applications: null,
      environments: {},
      roles: {},
      infrastructureApplications: {},
      user_ids: {},
      directory: {},
      settings: null,
      user_settings: null,
      user_delegates: null,
      landingZoneRoles: null,
    },
    fetching: {
      applications: false,
      environments: {},
      roles: {},
      infrastructureApplications: {},
      user_ids: {},
      directory: {},
      settings: false,
      user_settings: false,
      user_delegates: false,
      landingZoneRoles: false,
    },
  },
  action: Action
): Network {
  switch (action.type) {
    case ActionType.GET_APPLICATIONS_REQUEST:
      return {
        error: {
          ...state.error,
          applications: null,
        },
        fetching: {
          ...state.fetching,
          applications: true,
        },
      };
    case ActionType.GET_APPLICATIONS_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          applications: false,
        },
      };
    case ActionType.GET_APPLICATIONS_FAILURE:
      return {
        error: {
          ...state.error,
          applications: action.error,
        },
        fetching: {
          ...state.fetching,
          applications: false,
        },
      };
    case ActionType.GET_ENVIRONMENTS_REQUEST:
      return {
        error: {
          ...state.error,
          environments: {
            ...state.error.environments,
            [action.key]: null,
          },
        },
        fetching: {
          ...state.fetching,
          environments: {
            ...state.fetching.environments,
            [action.key]: true,
          },
        },
      };
    case ActionType.GET_ENVIRONMENTS_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          environments: {
            ...state.fetching.environments,
            [action.key]: false,
          },
        },
      };
    case ActionType.GET_ENVIRONMENTS_FAILURE:
      return {
        error: {
          ...state.error,
          environments: {
            ...state.error.environments,
            [action.key]: action.error,
          },
        },
        fetching: {
          ...state.fetching,
          environments: {
            ...state.fetching.environments,
            [action.key]: false,
          },
        },
      };
    case ActionType.GET_ROLES_REQUEST:
      return {
        error: {
          ...state.error,
          roles: {
            ...state.error.roles,
            [action.key]: null,
          },
        },
        fetching: {
          ...state.fetching,
          roles: {
            ...state.fetching.roles,
            [action.key]: true,
          },
        },
      };
    case ActionType.GET_ROLES_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          roles: {
            ...state.fetching.roles,
            [action.key]: false,
          },
        },
      };
    case ActionType.GET_ROLES_FAILURE:
      return {
        error: {
          ...state.error,
          roles: {
            ...state.error.roles,
            [action.key]: action.error,
          },
        },
        fetching: {
          ...state.fetching,
          roles: {
            ...state.fetching.roles,
            [action.key]: false,
          },
        },
      };
    case ActionType.GET_INFRASTRUCTURE_APPLICATIONS_REQUEST:
      return {
        error: {
          ...state.error,
          infrastructureApplications: {
            ...state.error.infrastructureApplications,
            [action.key]: null,
          },
        },
        fetching: {
          ...state.fetching,
          infrastructureApplications: {
            ...state.fetching.infrastructureApplications,
            [action.key]: true,
          },
        },
      };
    case ActionType.GET_INFRASTRUCTURE_APPLICATIONS_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          infrastructureApplications: {
            ...state.fetching.infrastructureApplications,
            [action.key]: false,
          },
        },
      };
    case ActionType.GET_INFRASTRUCTURE_APPLICATIONS_FAILURE:
      return {
        error: {
          ...state.error,
          infrastructureApplications: {
            ...state.error.infrastructureApplications,
            [action.key]: action.error,
          },
        },
        fetching: {
          ...state.fetching,
          infrastructureApplications: {
            ...state.fetching.infrastructureApplications,
            [action.key]: false,
          },
        },
      };
    case ActionType.GET_USER_ID_REQUEST:
      return {
        error: {
          ...state.error,
          user_ids: {
            ...state.error.user_ids,
            [action.email]: null,
          },
        },
        fetching: {
          ...state.fetching,
          user_ids: {
            ...state.fetching.user_ids,
            [action.email]: true,
          },
        },
      };
    case ActionType.GET_USER_ID_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          user_ids: {
            ...state.fetching.user_ids,
            [action.email]: false,
          },
        },
      };
    case ActionType.GET_USER_ID_FAILURE:
      return {
        error: {
          ...state.error,
          user_ids: {
            ...state.error.user_ids,
            [action.email]: action.error,
          },
        },
        fetching: {
          ...state.fetching,
          user_ids: {
            ...state.fetching.user_ids,
            [action.email]: false,
          },
        },
      };
    case ActionType.GET_DIRECTORY_REQUEST:
      return {
        error: {
          ...state.error,
          directory: {
            ...state.error.directory,
            [action.search]: null,
          },
        },
        fetching: {
          ...state.fetching,
          directory: {
            ...state.fetching.directory,
            [action.search]: true,
          },
        },
      };
    case ActionType.GET_DIRECTORY_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          directory: {
            ...state.fetching.directory,
            [action.search]: false,
          },
        },
      };
    case ActionType.GET_DIRECTORY_FAILURE:
      return {
        error: {
          ...state.error,
          directory: {
            ...state.error.directory,
            [action.search]: action.error,
          },
        },
        fetching: {
          ...state.fetching,
          directory: {
            ...state.fetching.directory,
            [action.search]: false,
          },
        },
      };
    case ActionType.GET_SETTINGS_REQUEST:
      return {
        error: {
          ...state.error,
          settings: null,
        },
        fetching: {
          ...state.fetching,
          settings: true,
        },
      };
    case ActionType.GET_SETTINGS_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          settings: false,
        },
      };
    case ActionType.GET_SETTINGS_FAILURE:
      return {
        error: {
          ...state.error,
          settings: action.error,
        },
        fetching: {
          ...state.fetching,
          settings: false,
        },
      };
    case ActionType.GET_USER_SETTINGS_REQUEST:
      return {
        error: {
          ...state.error,
          user_settings: null,
        },
        fetching: {
          ...state.fetching,
          user_settings: true,
        },
      };
    case ActionType.GET_USER_SETTINGS_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          user_settings: false,
        },
      };
    case ActionType.GET_USER_SETTINGS_FAILURE:
      return {
        error: {
          ...state.error,
          user_settings: action.error,
        },
        fetching: {
          ...state.fetching,
          user_settings: false,
        },
      };
    case ActionType.GET_USER_DELEGATES_REQUEST:
      return {
        error: {
          ...state.error,
          user_delegates: null,
        },
        fetching: {
          ...state.fetching,
          user_delegates: true,
        },
      };
    case ActionType.GET_USER_DELEGATES_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          user_delegates: false,
        },
      };
    case ActionType.GET_USER_DELEGATES_FAILURE:
      return {
        error: {
          ...state.error,
          user_delegates: action.error,
        },
        fetching: {
          ...state.fetching,
          user_delegates: false,
        },
      };
    case ActionType.GET_LANDING_ZONE_ROLES_REQUEST:
      return {
        error: {
          ...state.error,
          landingZoneRoles: null,
        },
        fetching: {
          ...state.fetching,
          landingZoneRoles: true,
        },
      };
    case ActionType.GET_LANDING_ZONE_ROLES_SUCCESS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          landingZoneRoles: false,
        },
      };
    case ActionType.GET_LANDING_ZONE_ROLES_FAILURE:
      return {
        error: {
          ...state.error,
          landingZoneRoles: action.error,
        },
        fetching: {
          ...state.fetching,
          landingZoneRoles: false,
        },
      };
    default:
      return state;
  }
}
